import request from "@/utils/request";

// 查询BusCourse详细
export function getBusCourse(id) {
  return request({
    url: "/api/v2/course/" + id,
    method: "get",
  });
}

// 普通用户查看BusCourse列表
export function getCourseList() {
  return request({
    url: "/api/v2/course/list",
    method: "get",
  });
}

export function getMyCourseList() {
  return request({
    url: "/api/v2/course/mine",
    method: "get",
  });
}
export function getLesson(id) {
  return request({
    url: "/api/v2/lesson/" + id,
    method: "get",
  });
}

export function getQuestion(id) {
  return request({
    url: "/api/v2/question/" + id,
    method: "get",
  });
}

export function unitTest(data) {
  return request({
    url: "/api/v2/question/unit-test",
    method: "post",
    data,
  });
}

export function getExamList() {
  return request({
    url: "/api/v2/user-exam",
    method: "get",
  });
}

export function getExam(id) {
  return request({
    url: "/api/v2/user-exam/" + id,
    method: "get",
  });
}

export function addBsUserCompletedLesson(data) {
  return request({
    url: "/api/v2/myLesson",
    method: "post",
    data,
  });
}

export function getUserCompleteLesson(id) {
  return request({
    url: "/api/v2/myLesson/" + id,
    method: "get",
  });
}



export function getCaseList(data) {
  return request({
    url: "/api/v2/case/list",
    params: data,
    method: 'get'
  });
}

export function getCase(id) {
  return request({
    url: "/api/v2/case/" + id,
    method: "get",
  });
}

export function getLiveList(data) {
  return request({
    url: "/api/v2/live/list",
    params: data,
  });
}

export function getLiveJump(params) {
  return request({
    url: "/api/v2/live/jump/" + params.id,
    method: "get",
  });
}
export function getQuestionRank(params) {
  return request({
    url: "/api/v2/live/question/rank",
    method: "get",
    params
  });
}

export function getNewsList(data) {
  return request({
    url:
      "/api/v2/news/list?pageIndex" +
      "=" +
      data.pageIndex +
      "&pageSize=" +
      data.pageSize,
    method: "get",
  });
}

export function getNewsDetail(id) {
  return request({
    url: "/api/v2/news/" + id,
    method: "get",
  });
}

export function getMemberGoods() {
  return request({
    url: "api/v2/member/goods",
    method: "get",
  });
}

export function createOrder(data) {
  return request({
    url: "api/v2/member/create",
    method: "post",
    data,
  });
}

export function checkOrderPayment(data) {
  return request({
    url: "api/v2/member/payCheck",
    method: "post",
    data,
  });
}

export function getLables() {
  return request({
    url: "/api/v2/tag/list",
    method: "get",
  });
}

export function getTopicList(data) {
  return request({
    url: "/api/v2/bs-live-topic/list",
    params: data,
    method: "get",
  });
}

export function getTopicInfo(data) {
  return request({
    url: "/api/v2/bs-live-topic/" + data.id,
    method: "get",
  });
}


export function getLiveDetail(id) {
  return request({
    url: "/api/v2/live/" + id,
    method: "get",
  });
}

export function addLivePv(params) {
  return request({
    url: "/api/v2/live/addPv",
    method: "get",
    params,
  });
}

export function buyLive(data) {
  return request({
    url: "/api/v2/live/buy",
    method: "post",
    data,
  });
}
